import React, { useEffect, useRef } from "react";
import { IAssetViewerProps } from "..";

import "./AudioAssetViewer.css";

interface IAudioAssetViewerProps {
  asset: IAsset;
}

const AudioAssetViewer = ({ asset }: IAudioAssetViewerProps) => {
  const audioRef = useRef<any>(null);
  useEffect(() => {
    audioRef.current.load();
  }, [asset]);

  if (!asset) {
    return null;
  }

  return render(asset, audioRef);
};

export function render(asset: IAsset, audioRef: any) {
  return (
    <div className="mv-asset-viewer mv-asset-viewer__container">
      <div
        className="mv-asset-viewer__asset--audio"
        style={{
          backgroundImage: `url(${asset.media.medium})`,
        }}
      >
        <div className="mv-media-player">
          <audio ref={audioRef} controls className="mv-audio-player">
            <source src={asset.media.stream} />
          </audio>
        </div>
      </div>
    </div>
  );
}

export default AudioAssetViewer;
